import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function Header() {
  const [theme, setTheme] = useState('dark')
  const navigate = useNavigate()

  useEffect(() => {
    // Load saved theme preference or detect system preference
    const savedTheme = localStorage.getItem('dx_theme')
    if (savedTheme) {
      setTheme(savedTheme)
      if (savedTheme === 'light') {
        document.body.classList.add('light')
      } else {
        document.body.classList.remove('light')
      }
    } else {
      // Default to dark
      setTheme('dark')
      document.body.classList.remove('light')
    }
  }, [])

  const toggleTheme = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark'
    setTheme(nextTheme)
    localStorage.setItem('dx_theme', nextTheme)
    
    if (nextTheme === 'light') {
      document.body.classList.add('light')
    } else {
      document.body.classList.remove('light')
    }
  }

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (window.location.pathname !== '/') {
      navigate('/')
      // Wait for navigation then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    } else {
      // Already on home, just scroll
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <header className="flex items-center justify-between gap-2 md:gap-4 py-3.5 pb-7">
      <Link to="/" className="flex items-baseline gap-2.5 hover:opacity-80 transition-opacity">
        <div className="font-mono text-xs tracking-wide text-muted-dark">
          deedslab.com<span className="opacity-55 hidden sm:inline">  //  record</span>
        </div>
      </Link>

      <nav className="flex items-center gap-2 md:gap-6 font-mono text-xs tracking-wide text-muted-dark" aria-label="Primary">
        <button
          onClick={() => scrollToSection('experiments')}
          className="py-2.5 hover:text-accent-dark transition-colors cursor-pointer hidden md:block"
        >
          Experiments
        </button>
        <Link
          to="/notes"
          className="py-2.5 hover:text-accent-dark transition-colors hidden md:block"
        >
          Observations
        </Link>
        <button
          onClick={() => scrollToSection('tools')}
          className="py-2.5 hover:text-accent-dark transition-colors cursor-pointer hidden md:block"
        >
          Tools
        </button>
        <button 
          onClick={() => scrollToSection('context')}
          className="py-2.5 hover:text-accent-dark transition-colors cursor-pointer hidden md:block"
        >
          Context
        </button>
        <button 
          onClick={toggleTheme}
          className="inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 border border-border-dark rounded-full bg-surface-dark-1 cursor-pointer select-none hover:border-accent-dark transition-colors flex-shrink-0"
          type="button" 
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? (
            // Sun icon for light mode
            <svg className="w-4 h-4 md:w-5 md:h-5 text-text-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ) : (
            // Moon icon for dark mode
            <svg className="w-4 h-4 md:w-5 md:h-5 text-text-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
          )}
        </button>
      </nav>
    </header>
  )
}

